<template>
  <v-card height="400" class="pa-8 d-flex flex-column  align-center">
    <div class="flex-grow-1" style="width: 100%">
      <h3 class="py-2">Clone Event</h3>
      <hr />
      <h4 class="mt-2">{{ event.name }}</h4>
      <div class="event-date-time">
        {{ eventTime(event.details.start) }} -
        {{ eventTime(event.details.end) }}
        <small>{{ event.details.timezone }}</small>
      </div>
      <div class="event-location">
        <a
          :href="
            `/venue/edit/${event.details.venue.id}?selectedOrgUnit=${event.details.orgUnit.id}`
          "
          >{{ event.details.venue.name }}</a
        >
        <small v-if="event.details.field" class="m1-2">
          -
          {{
            event.details.orgUnit.sport &&
              event.details.orgUnit.sport.fieldLabel + ": "
          }}
          {{ event.details.field }}</small
        >
      </div>
      <div>Reminders: {{ getEventReminderText() }}</div>

      <div class="mt-4 pa-4 mb-4" style="background-color: #efefef">
        Repeat every
        <v-select
          hide-details
          v-model="interval"
          solo
          dense
          style="max-width: 100px; display: inline-flex"
          :items="['Day', 'Week', 'Month']"
        />
        for
        <v-text-field
          hide-details
          v-model="iterations"
          type="number"
          solo
          dense
          style="max-width: 75px; display: inline-flex"
        />
        <v-checkbox
          v-model="playerInvites"
          hide-details
          dense
          label="Include Player Invites"
        />
        <v-checkbox
          v-model="eventReminders"
          hide-details
          dense
          label="Include Event Reminders"
        />
      </div>
    </div>
    <div>
      <CommonButton
        @handleClick="$emit('cancel')"
        color="transparent"
        :label="$t('common.cancel')"
        width="100"
        customClassName="secondary--text font-weight-medium"
      />
      <CommonButton
        color="primary"
        :label="$t('common.yes')"
        width="100"
        customClassName="ml-2"
        @handleClick="clone"
      />
    </div>
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { ModuleTypes } from "@/store/ModuleTypes";
import CommonButton from "@/views/academy/common/CommonButton";
import * as moment from "moment";
import { cloneEvent } from "@/helpers/api";
import { bus } from "@/main";

export default {
  name: "CloneEventModal",
  components: { CommonButton },
  props: {
    teamId: { type: String },
    event: { type: Object }
  },
  data: () => {
    return {
      interval: "Day",
      iterations: 1,
      playerInvites: false,
      eventReminders: false
    };
  },
  mounted() {},
  methods: {
    async clone() {
      bus.$emit("loadingOn");
      const body = new FormData();
      body.append("eventId", this.event.id);
      body.append("frequency", this.interval);
      body.append("count", this.iterations);
      body.append("cloneInvites", this.playerInvites);
      body.append("cloneReminders", this.eventReminders);
      try {
        const resp = await cloneEvent(this.teamId, body);
        if (resp.data.success) {
          bus.$emit("successSnack", resp.data.message);
          bus.$emit("refetchTeam");
          this.$emit("cancel");
        } else {
          bus.$emit("errorSnack", resp.data.message);
        }
      } catch (e) {
        bus.$emit("errorSnack", "Event could not be cloned, please try again.");
      }
      bus.$emit("loadingOff");
    },
    eventTime(time) {
      return moment(time).format(`h:mm A`);
    },
    getEventReminderText() {
      if (
        this.event.details.oneWeekReminder &&
        this.event.details.twoDayReminder
      ) {
        return "Morning-of and One Week Reminders";
      } else if (this.event.details.oneWeekReminder) {
        return "One Week Reminders";
      } else if (this.event.details.twoDayReminder) {
        return "Morning-of Reminder";
      } else {
        return "None";
      }
    }
  }
};
</script>

<style scoped>
.event-location a {
  font-size: 14px;
  text-decoration: none !important;
}
</style>
